import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromLocations from './pwa-locations.reducer';
import { PwaLocationsEffects } from './pwa-locations.effects';
import { PwaLocationsFacade } from './pwa-locations.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromLocations.PWA_LOCATIONS_FEATURE_KEY,
      fromLocations.reducer
    ),
    EffectsModule.forFeature([PwaLocationsEffects]),
  ],
  providers: [PwaLocationsFacade],
})
export class PwaLocationsStateModule {}
